var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    fill: "url(#paint0_linear_205_3417)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4954 26.152H18.1834V38.696C18.1834 39.2293 18.1727 39.816 18.1514 40.456C18.1514 41.0747 18.1407 41.6933 18.1194 42.312C18.098 42.9307 18.066 43.4853 18.0234 43.976C18.002 44.4453 17.9807 44.808 17.9594 45.064H18.0874L30.6634 26.152H33.8634V49H31.1754V36.584C31.1754 36.008 31.186 35.3893 31.2074 34.728C31.2287 34.0453 31.25 33.3947 31.2714 32.776C31.314 32.136 31.346 31.5707 31.3674 31.08C31.3887 30.5893 31.41 30.2267 31.4314 29.992H31.3034L18.6954 49H15.4954V26.152ZM51.1939 25.832V28.648C53.6685 28.6907 55.6205 29.096 57.0499 29.864C58.4792 30.632 59.4925 31.656 60.0899 32.936C60.6872 34.1947 60.9859 35.6027 60.9859 37.16C60.9859 38.184 60.8259 39.208 60.5059 40.232C60.2072 41.2347 59.6845 42.152 58.9379 42.984C58.1912 43.7947 57.1885 44.456 55.9299 44.968C54.6712 45.48 53.0925 45.7573 51.1939 45.8V49.32H48.3459V45.8C46.4045 45.7573 44.7939 45.48 43.5139 44.968C42.2552 44.4347 41.2632 43.752 40.5379 42.92C39.8125 42.0667 39.3005 41.1387 39.0019 40.136C38.7032 39.1333 38.5539 38.1413 38.5539 37.16C38.5539 36.0293 38.7139 34.9627 39.0339 33.96C39.3752 32.936 39.9192 32.04 40.6659 31.272C41.4339 30.4827 42.4472 29.8533 43.7059 29.384C44.9645 28.9147 46.5112 28.6693 48.3459 28.648V25.832H51.1939ZM48.3459 31.08C46.6392 31.1227 45.2739 31.4 44.2499 31.912C43.2472 32.424 42.5325 33.128 42.1059 34.024C41.6792 34.8987 41.4659 35.9333 41.4659 37.128C41.4659 38.3867 41.7005 39.4853 42.1699 40.424C42.6605 41.3413 43.4072 42.056 44.4099 42.568C45.4339 43.08 46.7459 43.368 48.3459 43.432V31.08ZM51.1939 43.432C52.8365 43.368 54.1592 43.0693 55.1619 42.536C56.1859 42.0027 56.9219 41.2773 57.3699 40.36C57.8392 39.4213 58.0739 38.344 58.0739 37.128C58.0739 35.912 57.8605 34.8667 57.4339 33.992C57.0072 33.096 56.2925 32.4027 55.2899 31.912C54.2872 31.4 52.9219 31.1227 51.1939 31.08V43.432Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_3417",
    x1: -0.00000224366,
    y1: -24.6667,
    x2: 53.1875,
    y2: 114.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D3FE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#602093"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.a4456fe6b2abfd1282914500cd269b85.svg";
export { ForwardRef as ReactComponent };